// extracted by mini-css-extract-plugin
export default {"Order":"Order__Order___ql7w0","orderList":"Order__orderList___bMGGC","orderItem":"Order__orderItem___GePRi","alertDanger":"Order__alertDanger___O9wWq"};